import { type LiteQuote } from '@frontend/api/src/quotes/quoteHeader/types';

import quoteService from 'services/quoteService';

import { stores } from 'store/configureStore';
import { receiveQuote } from 'store/quotes/actions';
import { getGroupId } from 'store/session/selectors';

import history from 'utils/browserHistory';

import { getQuote, getQuoteNumberWithRevision } from './selectors';

export const replaceUrlfromNewQuote = (quote: any) => {
  const nextUrl = `/quotes/edit/${quote.quoteNumberWithRevision}`;
  history.push(nextUrl);
};

let tempQuote: Promise<LiteQuote> | null = null;

export const getOrCreateQuote = async (replaceUrl = true) => {
  const numberAndRevision = getQuoteNumberWithRevision(
    stores.global?.getState() ?? {},
  );
  if (!numberAndRevision) {
    const groupId = getGroupId(stores.global!.getState());
    let quote;
    if (tempQuote) {
      quote = await tempQuote;
    } else {
      tempQuote = quoteService.create(groupId);
      quote = await tempQuote;
    }
    tempQuote = null;
    stores.global?.dispatch(receiveQuote(quote));
    if (replaceUrl) {
      replaceUrlfromNewQuote(quote);
    }
    return quote;
  } else {
    return getQuote(stores.global?.getState());
  }
};
